<template lang="html">

    <section class="actualidad wrapper">
  
      <section class="intro -categoria column-center" :min="min">
  
        <h1 ref="title">Noticias</h1>
  
      </section>
  
  
      <template v-if="!!noticias">

        <div class="contenedor-buscador row-center">
          <input type="text" placeholder="Escribe para buscar" v-model="buscador">
          <select v-model="categoria">
            <option value="">Filtra por categoría</option>
            <option :value="cat.slug" v-for="(cat,key) in categorias">{{cat.nombre}}</option>
          </select>
          <span :show="!!buscador | !!categoria">{{noticias.length}} {{noticias.length | resultado}}</span>
        </div>
  
        <div class="contenedor-noticias row-start container aifs" v-if="noticias.length > 0">
          <noticia v-for="(noticia, key) in noticias" :key="key" :data="noticia"></noticia>
        </div>
  
        <div class="error" v-if="showerror && noticias.length == 0">
          <h2>Lo sentimos no hay noticias</h2>
        </div>
  
      </template>
  
  
    </section>
  
  </template>
  
  <script lang="js">
  
    import { mapGetters, mapActions } from 'vuex'
  
    import noticia from '@/components/parts/noticia-el'
  
    export default {
      name: 'actualidad',
      data() {
        return {
          showerror: false,
          min : false,
          buscador : '',
          categoria : ''
        }
      },
      computed: {
        ...mapGetters({
          categorias: 'categoriaNoticias',
          getNoticias: 'getNoticias',
        }),
        noticias(){
          let noticias = new Array();

          let searchIn = ['titulo', 'entradilla'];

          if(!!this.getNoticias){

              noticias = this.getNoticias.filter( n => {

                let has = false;

                  searchIn.forEach(f => {
                    if(n[f].toLowerCase().indexOf(this.buscador.toLowerCase()) != -1){
                      has = true;
                      }
                  })

                  return has;

              });

              if(!!this.categoria){

                noticias = noticias.filter(n => {
                  return (n.categoria.slug == this.categoria)
                })

              }

          }

          return noticias;
        }
      },
      components: {
        'noticia': noticia
      },
      filters: {
        resultado(value){
          return (value != 1) ? 'resultados' : 'resultado'
        }
      },
    }
  </script>
  
  <style scoped lang="scss">
    .intro{
      overflow: hidden;
    }
  </style>


// WEBPACK FOOTER //
// src/components/views/noticias.vue